// Mock data for Omar Mosallam's Architecture Portfolio

export const personalInfo = {
  name: "Omar Mosallam",
  title: "Architect & Fitout Expert",
  subtitle: "RIBA/ARB (Part II)",
  nationality: "Dual National: Saudi–Egyptian",
  phones: ["+966 53 815 9462", "+20 128 818 1123"],
  email: "omar.mosallam@outlook.com",
  linkedin: "https://www.linkedin.com/in/omar-mosallam-343b91138/",
  bio: "I am an architect specializing in the delivery of complex turnkey projects, bridging design intent with precise technical execution. Over the past decade, I have led multidisciplinary teams across Saudi Arabia and Egypt, delivering high-profile retail, office, and business park developments.",
  mission: "My focus is on quality, innovation, and client satisfaction, ensuring that projects are executed to international standards and aligned with business goals."
};

export const projects = [
  // Current Role - Head of Technical Office (EGY & KSA) - 2025-Present
  {
    id: 1,
    name: "Okhtein Flagship Store",
    location: "Kingdom Center Tower, Riyadh",
    role: "Head of Technical Office",
    area: "150 m²",
    status: "Ongoing",
    year: "2025",
    type: "Luxury Retail",
    client: "Okhtein",
    company: "Sigma Contractors",
    period: "2025-Present",
    description: "Leading technical coordination for a luxury fashion brand's flagship store in one of Riyadh's most prestigious locations. Oversaw design-to-execution coordination ensuring international quality benchmarks.",
    keyAchievements: [
      "Seamless integration of architectural and MEP packages",
      "Maintained international luxury retail standards",
      "Delivered within premium mall operational constraints"
    ],
    technologies: ["AutoCAD", "MS Project", "BIM Coordination", "MEP Integration"],
    images: null // Remove placeholder images
  },
  {
    id: 2,
    name: "Extra Store Renovation",
    location: "Grenada Mall, Riyadh",
    role: "Head of Technical Office",
    area: "2,500 m²",
    status: "Ongoing",
    year: "2025",
    type: "Large Scale Retail",
    client: "Extra",
    company: "Sigma Contractors",
    period: "2025-Present",
    description: "Major retail renovation project managing comprehensive store redesign and technical coordination across multiple trades while maintaining store operations.",
    keyAchievements: [
      "Phased delivery maintaining operational continuity",
      "Complex MEP coordination in active retail environment",
      "Zero downtime during critical renovation phases"
    ],
    technologies: ["Phased Construction Planning", "Live Environment Coordination", "Advanced MEP Systems"],
    images: null // No photos available
  },
  {
    id: 3,
    name: "Agora Restaurant",
    location: "Grand Egyptian Museum, Cairo",
    role: "Head of Technical Office",
    area: "750 m²",
    status: "Ongoing",
    year: "2025",
    type: "Restaurant & Cultural",
    client: "Grand Egyptian Museum",
    company: "Sigma Contractors",
    period: "2025-Present",
    description: "Leading coordination of architectural, structural, and MEP trades in a sensitive cultural landmark. Managing client communication and heritage compliance requirements.",
    keyAchievements: [
      "100% compliance with cultural preservation standards",
      "Successful coordination in heritage environment",
      "Timely approvals from cultural authorities"
    ],
    technologies: ["Heritage-compliant Design", "Cultural Preservation Protocols", "Multi-trade Coordination"],
    renderOnly: true, // Special flag to show only render section in detail page
    images: { 
      main: "/images/projects/agora/photo1.jpg", // Same as render for Featured Projects
      render: "/images/projects/agora/photo1.jpg", // Only render photo available
      gallery: []
    }
  },
  {
    id: 4,
    name: "Ecolab HQ",
    location: "Cairo Festival City, Cairo",
    role: "Head of Technical Office",
    area: "1,000 m²",
    status: "Ongoing",
    year: "2025",
    type: "Corporate Office",
    client: "Ecolab",
    company: "Sigma Contractors",
    period: "2025-Present",
    description: "Directing technical documentation and approvals for corporate HQ fit-out. Implementing streamlined workflows for faster project delivery.",
    keyAchievements: [
      "Streamlined approval workflows by 30%",
      "Zero technical revision cycles achieved",
      "Enhanced consultant-contractor coordination"
    ],
    technologies: ["Technical Documentation Systems", "Workflow Optimization", "Quality Assurance"],
    images: { 
      main: "/images/projects/ecolab/photo1.jpg", // Largest file as main
      render: "/images/projects/ecolab/photo2.jpg", // Second photo as render
      gallery: [
        "/images/projects/ecolab/photo3.jpg",
        "/images/projects/ecolab/photo4.jpg", 
        "/images/projects/ecolab/photo5.jpg",
        "/images/projects/ecolab/photo6.jpg"
      ]
    }
  },
  {
    id: 5,
    name: "M Squared Offices",
    location: "Golf Central Business Park, Cairo",
    role: "Head of Technical Office",
    area: "2,500 m²",
    status: "Ongoing",
    year: "2025",
    type: "Corporate Office",
    client: "M Squared",
    company: "Sigma Contractors", 
    period: "2025-Present",
    description: "Large-scale corporate office development with complex technical requirements and high-end finishes. Leading technical coordination across multiple building systems.",
    keyAchievements: [
      "Coordinated complex building systems integration",
      "Maintained premium office standards throughout",
      "Successful multi-phase delivery planning"
    ],
    technologies: ["Advanced Building Systems", "Multi-phase Coordination", "Premium Finishes Integration"],
    images: null // Remove placeholder images
  },
  {
    id: 6,
    name: "Residential Complex",
    location: "El Gouna, Hurghada Red Sea",
    role: "Head of Technical Office",
    area: "4,500 m²",
    status: "Ongoing",
    year: "2025",
    type: "Residential",
    client: "El Gouna Development",
    company: "Sigma Contractors",
    period: "2025-Present",
    description: "Large residential complex in Egypt's premier resort destination. Managing technical coordination for luxury residential units with resort-standard amenities.",
    keyAchievements: [
      "Luxury resort-standard technical execution",
      "Complex coastal construction challenges resolved",
      "Sustainable building practices implementation"
    ],
    technologies: ["Coastal Construction Techniques", "Luxury Residential Systems", "Environmental Compliance"],
    images: null // Remove placeholder images
  },
  // Previous Role - Technical Office Team Leader (2023-2025)
  {
    id: 7,
    name: "Property Finder HQ",
    location: "District 5, Cairo",
    role: "Technical Office Team Leader",
    area: "1,500 m²",
    status: "Completed",
    year: "2024",
    type: "Corporate Office",
    client: "Property Finder",
    company: "Sigma Contractors",
    period: "2023-2025",
    description: "Supervised technical team delivering comprehensive office fit-out package for leading real estate platform. Acted as bridge between consultants and site team.",
    keyAchievements: [
      "Successful technical team leadership and mentoring",
      "100% specification compliance achieved",
      "Effective consultant-contractor coordination"
    ],
    technologies: ["Team Leadership", "Technical Review", "Quality Control Systems"],
    images: { 
      main: "/images/projects/property-finder/photo1.jpg", // Main image - largest file
      render: "/images/projects/property-finder/photo2.jpg", // Render image
      gallery: [
        "/images/projects/property-finder/photo3.jpg",
        "/images/projects/property-finder/photo4.jpg", 
        "/images/projects/property-finder/photo5.jpg"
      ]
    }
  },
  {
    id: 8,
    name: "KODE Club Facilities",
    location: "Swan Lake Residence, Cairo",
    role: "Technical Office Team Leader",
    area: "5,500 m²",
    status: "Completed",
    year: "2024",
    type: "Recreation & Leisure",
    client: "KODE Club",
    company: "Sigma Contractors",
    period: "2023-2025",
    description: "Comprehensive clubhouse, nursery, and leisure pool facilities development. Led technical coordination for diverse recreational and educational spaces.",
    keyAchievements: [
      "Complex multi-use facility coordination",
      "Child safety standards implementation",
      "Advanced pool and leisure systems integration"
    ],
    technologies: ["Multi-use Facility Design", "Safety Systems", "Leisure Facility Engineering"],
    images: null // Remove placeholder images
  },
  {
    id: 9,
    name: "HDRIC HQ",
    location: "Pearl Des Rois - HDB, Cairo",
    role: "Technical Office Team Leader", 
    area: "3,000 m²",
    status: "Completed",
    year: "2024",
    type: "Corporate Office",
    client: "Housing & Development Real Estate Investment Company",
    company: "Sigma Contractors",
    period: "2023-2025",
    description: "Corporate headquarters for major real estate investment company. Delivered high-end office spaces with sophisticated building systems.",
    keyAchievements: [
      "Premium corporate standard execution",
      "Advanced building management systems",
      "Efficient space planning optimization"
    ],
    technologies: ["Corporate Office Systems", "Building Management", "Space Optimization"],
    images: null // Remove placeholder images
  },
  // LA7 Gym - Featured Project (moved from additionalProjects)
  {
    id: 13,
    name: "LA7 Gym",
    location: "Emaar's Uptown Cairo",
    role: "Junior Project Manager",
    area: "220 m²",
    status: "Completed",
    year: "2019",
    type: "Fitness & Recreation",
    client: "Emaar",
    company: "FineTouch Contractors",
    period: "2019",
    description: "Modern fitness facility development within Emaar's prestigious Uptown Cairo development. Managed technical coordination for state-of-the-art gym equipment installation and specialized flooring systems.",
    keyAchievements: [
      "Successful integration of advanced fitness equipment systems",
      "Specialized flooring and safety systems implementation",
      "Compliance with international fitness facility standards"
    ],
    technologies: ["Fitness Equipment Integration", "Specialized Flooring Systems", "HVAC for Fitness Facilities"],
    images: { 
      main: "/images/projects/la7/main.jpg",
      render: "/images/projects/la7/render.jpg",
      gallery: [
        "/images/projects/la7/photo1.jpg",
        "/images/projects/la7/photo2.jpg", 
        "/images/projects/la7/photo3.jpg",
        "/images/projects/la7/photo4.jpg",
        "/images/projects/la7/photo5.jpg"
      ]
    }
  },
  // Project Manager Role (2021-2023)
  {
    id: 10,
    name: "IKEA Mall of Arabia",
    location: "Mall of Arabia, Cairo",
    role: "Project Manager",
    area: "21,000 m²",
    status: "Completed",
    year: "2022",
    type: "Large Scale Retail",
    client: "IKEA",
    company: "FineTouch Contractors",
    period: "2021-2023",
    description: "Flagship project managing end-to-end execution of massive retail space. Led cross-functional teams across design, procurement, and construction phases.",
    keyAchievements: [
      "On-time delivery of 21,000 m² complex project",
      "Full compliance with IKEA global brand standards",
      "Successful leadership of 15+ cross-functional team members"
    ],
    technologies: ["Large-scale Project Management", "Global Standards Compliance", "Cross-functional Leadership"],
    images: { 
      main: "/images/projects/ikea/main.jpg", // Your IKEA store photo
      render: null, // No render for IKEA
      gallery: [
        "/images/projects/ikea/photo2.jpg",
        "/images/projects/ikea/photo3.jpg", 
        "/images/projects/ikea/photo4.jpg",
        "/images/projects/ikea/photo5.jpg"
      ]
    }
  },
  {
    id: 11,
    name: "Alfuttaim Orient Insurance HQ",
    location: "Cairo Festival City Business Park, Cairo",
    role: "Project Manager",
    area: "1,300 m²",
    status: "Completed",
    year: "2022",
    type: "Corporate Office",
    client: "Alfuttaim's Orient Insurance",
    company: "FineTouch Contractors",
    period: "2021-2023",
    description: "Corporate headquarters fit-out for major insurance company with sophisticated office systems and premium finishes.",
    keyAchievements: [
      "Premium corporate office delivery",
      "Advanced security systems integration",
      "Efficient project timeline execution"
    ],
    technologies: ["Corporate Systems", "Security Integration", "Premium Finishes"],
    images: { 
      main: "/images/projects/orient/photo1.jpg", // Largest file (11MB) as main
      render: "/images/projects/orient/photo2.jpg", // Second photo as render
      gallery: [
        "/images/projects/orient/photo3.jpg",
        "/images/projects/orient/photo4.jpg", 
        "/images/projects/orient/photo5.jpg",
        "/images/projects/orient/photo6.jpg",
        "/images/projects/orient/photo7.jpg"
      ]
    }
  },
  {
    id: 12,
    name: "Network International (FF&SF)",
    location: "Cairo Festival City Business Park, Cairo", 
    role: "Project Manager",
    area: "1,000 m²",
    status: "Completed",
    year: "2022",
    type: "Corporate Office",
    client: "Network International",
    company: "FineTouch Contractors",
    period: "2021-2023",
    description: "Modern office spaces for leading payment solutions company with cutting-edge technology integration. Managed FF&SF (Food, Fashion & Fun) sector office development project.",
    keyAchievements: [
      "Advanced technology infrastructure setup",
      "Modern collaborative workspace design",
      "Seamless IT systems integration"
    ],
    technologies: ["Technology Infrastructure", "Modern Office Systems", "IT Integration"],
    images: { 
      main: "/images/projects/network-international-ffsf/photo1.jpg",
      render: null, // No render for Network International FF&SF
      gallery: [
        "/images/projects/network-international-ffsf/photo2.jpg",
        "/images/projects/network-international-ffsf/photo3.jpg",
        "/images/projects/network-international-ffsf/photo4.jpg", 
        "/images/projects/network-international-ffsf/photo5.jpg"
      ]
    }
  },
  {
    id: 14,
    name: "Costa Coffee",
    location: "City Centre Almaza, Cairo", 
    role: "Junior Project Manager",
    area: "160 m²",
    status: "Completed",
    year: "2019",
    type: "Retail & Food Service",
    client: "Costa Coffee",
    company: "FineTouch Contractors",
    period: "2018-2019",
    description: "Modern coffee shop fit-out project for the globally recognized Costa Coffee brand. Managed technical coordination for specialized coffee equipment installation and brand-compliant interior design.",
    keyAchievements: [
      "Successful coffee equipment systems integration",
      "Brand-compliant interior design implementation",
      "Efficient retail space optimization"
    ],
    technologies: ["Coffee Equipment Systems", "Retail Interior Design", "Brand Compliance Standards"],
    images: { 
      main: "/images/projects/costa-coffee/photo3.jpg", // Switch to photo3 as main
      render: "/images/projects/costa-coffee/photo1.jpg", // photo1 as render
      gallery: [
        "/images/projects/costa-coffee/photo2.jpg",
        "/images/projects/costa-coffee/photo4.jpg", 
        "/images/projects/costa-coffee/photo5.jpg",
        "/images/projects/costa-coffee/photo6.jpg"
      ]
    }
  },
  {
    id: 15,
    name: "Network International (GF)",
    location: "Cairo Festival City Business Park, Cairo", 
    role: "Junior Project Manager",
    area: "3,200 m²",
    status: "Completed",
    year: "2020",
    type: "Corporate Office",
    client: "Network International",
    company: "FineTouch Contractors", 
    period: "2019-2020",
    description: "Large-scale corporate office development for Network International's GF (General Finance) division. Managed technical coordination for premium office fit-out with advanced technology integration.",
    keyAchievements: [
      "Successful delivery of 3,200 m² corporate space",
      "Advanced technology infrastructure implementation", 
      "Premium finish coordination and quality control"
    ],
    technologies: ["Technology Infrastructure", "Corporate Office Systems", "Premium Finishes"],
    images: { 
      main: "/images/projects/network-international-gf/photo1.jpg", // Largest file as main
      render: null, // No render image provided
      gallery: [
        "/images/projects/network-international-gf/photo2.jpg",
        "/images/projects/network-international-gf/photo3.jpg",
        "/images/projects/network-international-gf/photo4.jpg", 
        "/images/projects/network-international-gf/photo5.jpg",
        "/images/projects/network-international-gf/photo6.jpg"
      ]
    }
  }
];

export const additionalProjects = [
  // Junior Project Manager Projects (2018-2021)
  {
    name: "Costa Coffee",
    location: "City Centre Almaza, Cairo",
    area: "160 m²",
    year: "2019",
    role: "Junior Project Manager",
    type: "Retail & Food Service"
  },
  // Network International HQ upgraded to featured project as Network International (GF)
  {
    name: "Emaar Sales Center",
    location: "Capital Business Park, Cairo",
    area: "340 m²",
    year: "2020",
    role: "Junior Project Manager",
    type: "Commercial"
  },
  {
    name: "AXA OneHealth Medical Clinics",
    location: "Nile Towers Mall, Cairo",
    area: "140 m²",
    year: "2019",
    role: "Junior Project Manager",
    type: "Healthcare"
  },
  {
    name: "Daniel Hechter Store",
    location: "City Centre Almaza, Cairo",
    area: "240 m²",
    year: "2020",
    role: "Junior Project Manager",
    type: "Fashion Retail"
  },
  // Site Architect Projects (2017-2018)
  {
    name: "Lazurde Jewelry Store",
    location: "Maadi St.9, Cairo",
    area: "70 m²",
    year: "2017",
    role: "Site Architect",
    type: "Luxury Retail"
  },
  {
    name: "OR Store - Maadi",
    location: "City Centre Maadi, Cairo",
    area: "180 m²",
    year: "2017",
    role: "Site Architect",
    type: "Fashion Retail"
  },
  {
    name: "OR Store - City Stars",
    location: "City Stars Mall, Cairo",
    area: "380 m²",
    year: "2018",
    role: "Site Architect",
    type: "Fashion Retail"
  },
  {
    name: "Mobaco Cottons",
    location: "City Stars Mall, Cairo",
    area: "270 m²",
    year: "2018",
    role: "Site Architect",
    type: "Fashion Retail"
  },
  // Recent Small Projects
  {
    name: "Monkie Store",
    location: "U-Venues Mall, Cairo",
    area: "150 m²",
    year: "2024",
    role: "Technical Office Team Leader",
    type: "Retail"
  },
  {
    name: "Bibliothek Café & Library",
    location: "U-Venues Mall, Cairo", 
    area: "150 m²",
    year: "2024",
    role: "Technical Office Team Leader",
    type: "Food Service & Entertainment"
  },
  {
    name: "AEON Towers Common Areas",
    location: "Mall of Arabia, Cairo",
    area: "10,000 m²",
    year: "2022",
    role: "Project Manager",
    type: "Commercial Common Areas"
  }
];

export const timeline = [
  {
    year: "2025–Present",
    position: "Head of Technical Office (EGY & KSA)",
    company: "Sigma Contractors",
    companyGroup: "sigma", // Same company group to show promotion
    description: "Leading technical operations across Egypt and Saudi Arabia"
  },
  {
    year: "2023–2025",
    position: "Technical Office Team Leader",
    company: "Sigma Contractors",
    companyGroup: "sigma", // Same company group to show promotion
    description: "Team leadership and technical coordination"
  },
  {
    year: "2017–2023",
    position: "Site Architect → Junior PM → Project Manager",
    company: "FineTouch Contractors",
    companyGroup: "finetouch",
    description: "Progressive career growth through multiple roles"
  },
  {
    year: "2015",
    position: "Site Architect",
    company: "Details Contractors",
    companyGroup: "details",
    description: "Beginning of professional career"
  }
];

export const skills = {
  leadership: [
    "Team mentoring",
    "Workload distribution", 
    "QC monitoring",
    "Cross-functional leadership"
  ],
  technical: [
    "Shop drawings",
    "RFIs",
    "Submittals",
    "AutoCAD",
    "MS Project",
    "BIM Coordination"
  ],
  personal: [
    "Risk management",
    "Problem solving",
    "Stakeholder communication",
    "Quality assurance"
  ]
};

export const certificates = [
  {
    name: "RIBA Part II Validation Certificate",
    year: "2017",
    issuer: "RIBA"
  },
  {
    name: "Mastering AutoCAD",
    year: "2012",
    issuer: "Autodesk"
  },
  {
    name: "Mastering Photoshop",
    year: "2016",
    issuer: "Adobe"
  },
  {
    name: "Mastering 3Ds Max",
    year: "2017",
    issuer: "Autodesk"
  }
];

export const clientLogos = [
  // Global Brands (Most Well-Known)
  { name: "IKEA", hasLogo: true, logoPath: "/images/logos/ikea.png" },
  { name: "Costa Coffee", hasLogo: true, logoPath: "/images/logos/costa-coffee.png" },
  { name: "AXA", hasLogo: true, logoPath: "/images/logos/axa.png" },
  { name: "Ecolab", hasLogo: true, logoPath: "/images/logos/ecolab.png" },
  
  // Regional Well-Known Brands
  { name: "Property Finder", hasLogo: true, logoPath: "/images/logos/property-finder.png" },
  { name: "Network International", hasLogo: true, logoPath: "/images/logos/network-international.png" },
  { name: "Emaar", hasLogo: true, logoPath: "/images/logos/emaar.png" },
  { name: "Hassan Allam", hasLogo: true, logoPath: "/images/logos/hassan-allam.png" },
  
  // Shopping Centers & Malls
  { name: "Mall of Arabia", hasLogo: true, logoPath: "/images/logos/mall-of-arabia.png" },
  { name: "Mall of Egypt", hasLogo: true, logoPath: "/images/logos/mall-of-egypt.png" },
  { name: "Cairo Festival City", hasLogo: true, logoPath: "/images/logos/cairo-festival-city.png" },
  { name: "City Centre Maadi", hasLogo: true, logoPath: "/images/logos/city-centre-maadi.png" },
  { name: "Galleria 40", hasLogo: true, logoPath: "/images/logos/galleria-40.png" },
  
  // Fashion & Retail Brands
  { name: "Daniel Hechter", hasLogo: true, logoPath: "/images/logos/daniel-hechter.png" },
  { name: "Okhtein", hasLogo: true, logoPath: "/images/logos/okhtein.png" },
  { name: "Lazurde", hasLogo: true, logoPath: "/images/logos/lazurde.png" },
  { name: "Extra", hasLogo: true, logoPath: "/images/logos/extra.png" },
  { name: "Mobaco Cottons", hasLogo: true, logoPath: "/images/logos/mobaco-cottons.png" },
  
  // Cultural & Development
  { name: "Grand Egyptian Museum", hasLogo: true, logoPath: "/images/logos/grand-egyptian-museum.png" },
  { name: "Marakez", hasLogo: true, logoPath: "/images/logos/marakez.png" }
];

// AI & Technology Innovation
export const techInnovations = [
  {
    id: 1,
    title: "Automated Invoice Generation System",
    description: "Developed a comprehensive Python-based solution that automatically generates subcontractor invoices from client invoices, streamlining financial processes and reducing manual errors.",
    technologies: ["Python", "Google Colab", "ChatGPT API", "Gemini AI"],
    features: [
      "Automated data extraction from client invoices",
      "AI-powered cost breakdown and allocation",
      "Automatic subcontractor invoice generation",
      "PDF report generation with professional formatting",
      "Error detection and validation systems",
      "Integration with existing financial workflows"
    ],
    impact: [
      "Reduced invoice processing time by 95%",
      "Eliminated manual calculation errors",
      "Improved financial transparency and tracking",
      "Enhanced project cost management efficiency"
    ],
    year: "2024",
    status: "Implemented & Active",
    category: "Financial Automation"
  }
];

export const projectStats = {
  totalProjects: "50+",
  totalArea: "75,000+",
  yearsExperience: "10+",
  teamSize: "15+",
  projectValue: "$25M+",
  completionRate: "100%"
};